import { useState, useEffect, useCallback } from "react";
import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";

/** Short edge ≥ 600px ≈ native tablet; phones stay untouched. */
const NATIVE_TABLET_SHORT_SIDE = 600;

export function isNativeTabletViewport(): boolean {
  if (!isNativeCapacitorApp() || typeof window === "undefined") return false;
  return (
    Math.min(window.innerWidth, window.innerHeight) >= NATIVE_TABLET_SHORT_SIDE
  );
}

export function useIsNativeTablet() {
  const [isTablet, setIsTablet] = useState(() => isNativeTabletViewport());

  const handleResize = useCallback(() => {
    setIsTablet(isNativeTabletViewport());
  }, []);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    const debounced = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(handleResize, 100);
    };
    window.addEventListener("resize", debounced);
    handleResize();
    return () => {
      window.removeEventListener("resize", debounced);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [handleResize]);

  return isTablet;
}
